import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export function buildBreadcrumbSchema(items) {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const full = [{ label: "Accueil", path: "/" }, ...items];
  return {
    "@context": "https://schema.org", "@type": "BreadcrumbList",
    itemListElement: full.map((it, i) => ({
      "@type": "ListItem", position: i + 1, name: it.label,
      ...(it.path ? { item: `${origin}${it.path}` } : {}),
    })),
  };
}

export default function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" className="mb-6" data-testid="breadcrumbs">
      <ol className="flex items-center gap-1.5 text-xs text-zinc-500 flex-wrap">
        <li className="flex items-center">
          <Link to="/" className="hover:text-white transition-colors flex items-center" data-testid="breadcrumb-home">
            <Home className="w-3.5 h-3.5" />
          </Link>
        </li>
        {items.map((it, i) => (
          <li key={i} className="flex items-center gap-1.5">
            <ChevronRight className="w-3 h-3 text-zinc-600" />
            {it.path ? (
              <Link to={it.path} className="hover:text-white transition-colors" data-testid={`breadcrumb-link-${i}`}>{it.label}</Link>
            ) : (
              <span className="text-zinc-300 font-medium" data-testid={`breadcrumb-current-${i}`}>{it.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
